import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a delivered icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <DeliveredIcon width={12} />
 */
function DeliveredIcon(props) {
    return (
        <SvgIcon {...props}>
            <path
                d={`M39.6,13.977,38,12.349a1.1,1.1,0,0,0-1.608,0l-6.753,6.87c-.012.012-.026.02-.038.032L19.092,
                29.94l-5.738-5.812h0L11.56,22.311a1.1,1.1,0,0,0-1.608,0L8.344,23.939a1.134,1.134,0,0,0,0,1.628l1.794,
                1.817h0l6.478,6.561c.021.025.039.053.063.077l1.608,1.629a1.1,1.1,0,0,0,1.608,0L32.872,22.507a1.222,
                1.222,0,0,0,.112-.137l6.678-6.764A1.09,1.09,0,0,0,39.6,13.977Z`}
            />
        </SvgIcon>
    )
}

DeliveredIcon.defaultProps = defaultProps

export { DeliveredIcon }
